import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

export interface XlsColumn {
  header: string;
  dataKey: string;
  type?: 'currency' | 'number' | 'text' | 'date';
}

@Injectable({
  providedIn: 'root',
})
export class XlsExportService {

  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  EXCEL_EXTENSION = '.xlsx';

  constructor() { }

  private formatValue(value: any, type?: string): any {
    if (value === null || value === undefined) {
      return '';
    }

    switch (type) {
      case 'currency':
        if (typeof value === 'number') {
          return parseFloat(value.toFixed(2));
        }
        return value;

      case 'number':
        if (typeof value === 'number') {
          return value;
        }
        return value;

      case 'date':
        if (value instanceof Date) {
          return formatDate(value, 'dd/MM/yyyy', 'pl-PL');
        }
        return value;

      case 'text':
      default:
        return value;
    }
  }

  private formatDataForExcel(dane: any[], kolumny: XlsColumn[]): any[] {
    return dane.map(row => {
      const formattedRow = { ...row };

      kolumny.forEach(kolumna => {
        if (kolumna.type && formattedRow[kolumna.dataKey] !== undefined) {
          formattedRow[kolumna.dataKey] = this.formatValue(formattedRow[kolumna.dataKey], kolumna.type);
        }
      });

      return formattedRow;
    });
  }

  private formatHeaderForExport(header: string, type?: string): string {
    if (type === 'currency') {
      return `${header} [zł]`;
    }
    return header;
  }

  public export(dane: any[], kolumny: XlsColumn[], excelFileName: string): void {
    if (dane.length > 0) {
      const formattedDane = this.formatDataForExcel(dane, kolumny);
      const headersObject = kolumny.reduce((o, key) => Object.assign(o, {[key.dataKey]: this.formatHeaderForExport(key.header, key.type)}), {});
      const headers = [];
      headers.push(headersObject);
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(headers, { skipHeader: true });

      XLSX.utils.sheet_add_json(worksheet, formattedDane, {skipHeader: true, origin: 'A2'});

      const workbook: XLSX.WorkBook = {Sheets: {'raport': worksheet}, SheetNames: ['raport']};
      const excelBuffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
      this.saveAsExcelFile(excelBuffer, excelFileName);
    }
  }
  private saveAsExcelFile(buffer: any, baseFileName: string): void {
    const data: Blob = new Blob([buffer], {type: this.EXCEL_TYPE});
    FileSaver.saveAs(data, baseFileName + '_' + this.getDateFormat(new Date())  + this.EXCEL_EXTENSION);
  }

  private getDateFormat(date: Date): string {
    return formatDate(date, 'yyyyMMdd_HHmmss', 'pl-PL');
  }
}

// Stary interfejs dla kompatybilności wstecznej
export interface KolumnaEksportXLS {
  header: string;
  dataKey: string;
}
